import React, { useState } from "react";
import {
    Dialog,
    DialogType,
    ChoiceGroup,
    IChoiceGroupOption,
    TextField,
    DialogFooter,
    PrimaryButton,
    DefaultButton,
    Stack,
} from "@fluentui/react";
import { submitFeedback } from "src/services/aigc/workflowOnline";
import { msalInstance } from "src/lib/msalInstance";

interface Props {
    isOpen: boolean;
    onDismiss: () => void;
}

const aiFeatureOptions: IChoiceGroupOption[] = [
    { key: "pptgen", text: "PPT Generation" },
    { key: "aitool", text: "AI Tool" },
];

export const FeedbackDialog: React.FC<Props> = ({ isOpen, onDismiss }) => {
    const [aiFeature, setAiFeature] = useState<"pptgen" | "aitool">("pptgen");
    const [content, setContent] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        try {
            setIsSubmitting(true);
            const activeAccount = msalInstance.getAllAccounts()[0];
            if (!activeAccount) {
                throw new Error("No active account");
            }

            await submitFeedback({
                userEmail: activeAccount.username,
                content,
                aiFeature,
            });

            onDismiss();
            alert("Feedback submitted successfully!");
        } catch (error) {
            console.error("Failed to submit feedback:", error);
            alert("Failed to submit feedback. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Dialog
            hidden={!isOpen}
            onDismiss={onDismiss}
            dialogContentProps={{
                type: DialogType.normal,
                title: "Submit Feedback",
                subText: "Please provide your feedback about our AI features.",
            }}
            modalProps={{
                isBlocking: false,
                styles: { main: { maxWidth: 450 } },
            }}
        >
            <Stack tokens={{ childrenGap: 15 }}>
                <ChoiceGroup
                    label="Select AI Feature"
                    required
                    options={aiFeatureOptions}
                    selectedKey={aiFeature}
                    onChange={(_, option) => option && setAiFeature(option.key as "pptgen" | "aitool")}
                />
                <TextField
                    label="Feedback Content"
                    required
                    multiline
                    rows={4}
                    value={content}
                    onChange={(_, newValue) => setContent(newValue || "")}
                />
            </Stack>
            <DialogFooter>
                <PrimaryButton onClick={handleSubmit} text="Submit" disabled={!content || isSubmitting} />
                <DefaultButton onClick={onDismiss} text="Cancel" />
            </DialogFooter>
        </Dialog>
    );
};
